var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"dataTable",attrs:{"pageUnit":_vm.pagingInfo.pageUnit,"totalSize":_vm.pagingInfo.totalSize,"paging":"","index":"","columns":_vm.columns,"rows":_vm.rows,"fit":"fit","excel":_vm.isButton_(_vm.scrId, 'EX'),"customExcel":_vm.excelFunc},on:{"changedPage":_vm.changedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }